import React from 'react';
import { CheckmarkIcon } from '~/public/static/svg/CheckmarkIcon';

interface Props {
  title: string;
  postContent?: React.ReactNode;
  bulletItems: React.ReactNode[];
}

const ListFlowBaseDescription: React.FC<Props> = ({
  bulletItems,
  postContent,
  title,
}) => (
  <div /*className="sticky top-2"*/>
    <h3 className="mb-2 font-normal">{title}</h3>

    <ul className="mb-4">
      {bulletItems.map((bullet, i) => (
        <li
          key={i}
          className="text-slate-green-500 mb-2 flex space-x-2 text-sm"
        >
          <CheckmarkIcon className="flex-shrink-0 text-green-500" />
          {bullet}
        </li>
      ))}
    </ul>

    {postContent}
  </div>
);

export default ListFlowBaseDescription;
